import { ReactElement, useContext, useMemo } from "react"

import AppStepper from "../../../../dataDisplay/stepper/appStepper"
import { CreateV2GBundleContext } from "../providers/baseProviders/createV2GBundleProvider"

const CreateV2GBundleProgressStepper = (): ReactElement => {
    const { currentIndex, canEditManufacturer, generationMode } = useContext(
        CreateV2GBundleContext
    )

    const steps = useMemo(() => {
        const baseSteps = [
            "Core EV Charge Point (AC) Device Details",
            "Inverter Options",
        ]

        const generationSteps =
            generationMode === "new"
                ? [
                      "Core Inverter Details",
                      "Type Test Details",
                      "EVCP Supporting Files",
                      "Review and Submit",
                  ]
                : ["EVCP Supporting Files", "Review and Submit"]

        return canEditManufacturer
            ? ["Manufacturer", ...baseSteps, ...generationSteps]
            : [...baseSteps, ...generationSteps]
    }, [canEditManufacturer, generationMode])

    return <AppStepper stepLabels={steps} currentStepIndex={currentIndex} />
}

export default CreateV2GBundleProgressStepper
